module.exports = __webpack_public_path__ + "img/vess_logo.c9a873a3.png";